import React from 'react';

interface BuildTheDealProps {
  iconSize: number;
}

export const BuildTheDeal = ({iconSize}: BuildTheDealProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={iconSize}
    height={iconSize}
    viewBox="0 0 13 15"
    fill="none"
  >
    <g clipPath="url(#clip0_2082_6818)">
      <path
        d="M12.4429 3.65854H10.0286V3.47561C10.0286 1.55854 8.44629 0 6.5 0C4.55371 0 2.97143 1.55854 2.97143 3.47561V3.65854H0.557143C0.252571 3.65854 0 3.90732 0 4.20732V12.9878C0 14.1 0.913714 15 2.04286 15H10.9571C12.0863 15 13 14.1 13 12.9878V4.20732C13 3.90732 12.7474 3.65854 12.4429 3.65854ZM4.08571 3.47561C4.08571 2.16585 5.17029 1.09756 6.5 1.09756C7.82971 1.09756 8.91429 2.16585 8.91429 3.47561V3.65854H4.08571V3.47561ZM11.8857 12.9878C11.8857 13.4927 11.4697 13.9024 10.9571 13.9024H2.04286C1.53029 13.9024 1.11429 13.4927 1.11429 12.9878V4.7561H2.97143V6.40244C2.97143 6.70244 3.224 6.95122 3.52857 6.95122C3.83314 6.95122 4.08571 6.70244 4.08571 6.40244V4.7561H8.91429V6.40244C8.91429 6.70244 9.16686 6.95122 9.47143 6.95122C9.776 6.95122 10.0286 6.70244 10.0286 6.40244V4.7561H11.8857V12.9878Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_2082_6818">
        <rect width="13" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
